export const sizes = [24, 48, 72]

export const sortOptions = [
    {
        id: 'score',
        value: {
            name: 'Most relevant',
            sort: [
                {
                    field: 'score',
                    order: 'desc',
                },
            ],
        },
    },
    {
        id: '-price',
        value: {
            name: 'Price descending',
            sort: [
                {
                    field: 'price',
                    order: 'desc',
                },
            ],
        },
    },
    {
        id: 'price',
        value: {
            name: 'Price ascending',
            sort: [
                {
                    field: 'price',
                    order: 'asc',
                },
            ],
        },
    },
    {
        id: 'newest',
        value: {
            name: 'Newest',
            sort: [
                {
                    field: 'datePublished',
                    order: 'desc',
                },
            ],
        },
    }  
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteSize: 6,
    autocompleteKeywordsSize: 6,
    historySize: 5,
    currency: 'EUR'
}
